import { apiClient } from '@/api/apiClient'
import { useQuery } from '@tanstack/react-query'

type DefaultValue = {
  countryTwoLetter: string
  country: string
  product: string
  productCnCode: string
  description: string | null
  directEmissions: string | null
  indirectEmissions: string | null
  totalEmissions: string | null
  underlyingProductionRouteCbamBm: string | null
}

export const useGetDefaultValues = (
  code: string | undefined,
  country: string | undefined,
  year: number
) => {
  return useQuery<DefaultValue>({
    queryKey: ['defaultValue', code, country, year],
    queryFn: async () => {
      const response = await apiClient.get<DefaultValue>(
        `/v1/goods/${code}/default-values/${country}/${year}`
      )
      return response.data
    },
    enabled: !!code && !!country && !!year
  })
}
